import React from 'react';

export default function About() {
  return (
    <div className="min-h-screen bg-gray-50">
      <section className="relative -mt-32 mb-20">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="prose prose-lg max-w-none">
              <h1 className="text-3xl font-bold mb-8">About ICP EDGE</h1>
              
              <h2 className="text-2xl font-bold mb-4">Our Genesis</h2>
              <p className="mb-8">
                ICP EDGE was founded by Frank Seidel after 25+ years implementing enterprise technology solutions for Fortune 500 companies. During this extensive career, Seidel made a critical discovery: successful technology adoption isn't driven primarily by technical capabilities, but by psychological factors that conventional analysis consistently overlooks.
              </p>
              <p className="mb-12">
                This insight now translates into actionable investment intelligence for PE firms seeking acquisitions with stronger competitive moats and untapped growth opportunities.
              </p>

              <h2 className="text-2xl font-bold mb-4">Our Advantage</h2>
              <p className="mb-12">
                We provide proprietary behavioral intelligence methodologies that uncover hidden competitive moats traditional due diligence consistently misses. While conventional analysis focuses on financial metrics, market sizing, and feature comparisons, ICP EDGE reveals the psychological factors that truly determine why customers buy, stay, and pay premium prices.
              </p>

              <h2 className="text-2xl font-bold mb-4">Our Approach</h2>
              <p className="mb-4">Our proprietary frameworks include:</p>
              <div className="bg-blue-50 p-6 rounded-xl mb-8">
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2"></div>
                    <div>
                      <span className="font-semibold">Emotional Resonance Mapping™:</span> Identifies which emotional triggers create genuine customer loyalty beyond contractual obligations
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2"></div>
                    <div>
                      <span className="font-semibold">Psychological Moat Analysis™:</span> Quantifies the strength of invisible barriers protecting businesses from competitive encroachment
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2"></div>
                    <div>
                      <span className="font-semibold">Behavioral Value Creation Model™:</span> Translates psychological insights into concrete post-acquisition strategies with measurable ROI
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2"></div>
                    <div>
                      <span className="font-semibold">Competitive Emotional Positioning Matrix™:</span> Maps psychological territories competitors own in customers' minds
                    </div>
                  </li>
                </ul>
              </div>
              <p className="mb-12">
                Each methodology is systematically applied through modular engagement options aligned with your specific investment phase—from initial screening to post-acquisition value creation.
              </p>

              <h2 className="text-2xl font-bold mb-4">Our Impact</h2>
              <p className="mb-4">PE firms partnering with ICP EDGE gain decisive advantages:</p>
              <div className="bg-gray-50 p-6 rounded-xl mb-8">
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2"></div>
                    <div>Identify acquisition targets with stronger psychological moats than metrics suggest</div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2"></div>
                    <div>Avoid overpaying for businesses with strong metrics but weak emotional differentiation</div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2"></div>
                    <div>Discover hidden acquisition opportunities competitors consistently overlook</div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2"></div>
                    <div>Develop post-acquisition strategies that directly address the true drivers of customer behavior</div>
                  </li>
                </ul>
              </div>
              <p className="mb-12">
                Our behavioral intelligence helpes PE firms acquire targets at attractive multiples that other buyers avoid, reduce portfolio company churn, and implement premium pricing strategies with minimal impact on retention.
              </p>

              <h2 className="text-2xl font-bold mb-4">Our Promise</h2>
              <p className="mb-4">
                We deliver actionable intelligence aligned with PE timelines—comprehensive reports with clear investment implications in as little as two weeks. Our insights don't replace your judgment; they enhance it by quantifying what has traditionally been left to intuition.
              </p>
              <p className="mb-4">
                In a competitive deal environment where conventional methods yield conventional results, ICP EDGE provides the systematic advantage that separates market-followers from top-quartile performers.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}